export default {
  external_rfid_form_toast_update_error: 'Unfortunately there was an error',
  external_rfid_form_toast_update_success: 'Card activated successfully!',
  external_rfid_title: 'Your Cards',
  external_rfid_add_card_button: 'Add RFID Card',
  external_rfid_add_external_modal_title: 'Add RFID Card',
  external_rfid_add_external_modal_description:
    'Please enter the visible Number on your RFID Card.',
  external_rfid_add_external_input_label: 'RFID number',
  external_rfid_card_status_info_message:
    'If the external charging card is deactivated or malfunctions, please contact your leasing partner directly.',
  external_rfid_add_external_input_placeholder: 'ABC 1234 56789 DEFG',
  external_rfid_add_external_button: 'Add third-Party Card',
  external_rfid_add_external_success: 'Card was successfully added to your Account.',
  external_rfid_add_external_error: 'Failed to add external RFID card.',
  external_rfid_add_external_not_found:
    'Card not found. Please check the number and try again.',
  external_rfid_add_external_validation_required:
    'Please enter the RFID number',
  external_rfid_add_external_validation_invalid: 'Invalid RFID number format',
  external_rfid_add_external_checking: 'Checking card...',
  external_rfid_add_external_card_found: 'Card found!',
  external_rfid_nav_tariff: 'Tariff',
  external_rfid_modal_title: 'Activate RFID Card',
  external_rfid_common_required: 'Please Fill in',
  external_rfid_nav_charger: 'Charger',
  external_rfid_nav_payment: 'Payment',
  external_rfid_nav_profile: 'My Profile',
  external_rfid_use_private: 'Private charger card',
  external_rfid_use_external: 'Third Party Charging Card',
  external_rfid_status_processing: 'Processing',
  external_rfid_missing_text: "You currently don't have any cards.",
  external_rfid_nav_overview: 'Overview',
  external_rfid_status_error: 'error',
  external_rfid_use_business: 'Business Charging card',
  external_rfid_modal_success: 'Your card is activated',
  external_rfid_nav_documents: 'Documents',
  external_rfid_status_active: 'active',
  external_rfid_status_initial: 'Initial',
  external_rfid_status_ordered: 'Ready to Activate',
  external_rfid_status_inactive: 'Inactive',
  external_rfid_status_pending: 'Processing',
  contact_form_label_rfid_number: 'RFID number',
  external_rfid_nav_chargercards: 'Charging Cards',
  external_rfid_modal_button_done: 'Done',
  external_rfid_modal_description:
    'Please enter your RFID Number that you can find on your card or in the document. The Number needs to start with EnOS.',
  contact_form_validation_rfidNumber:
    'Must begin with ENOS and consists only of letters and numbers',
  external_rfid_button_activate_card: 'Activate Card',
  external_rfid_nav_customer_service: 'Support',
  external_rfid_modal_description_success:
    'Your activation was successful. You can now start using your RFID card with your charger',
  external_rfid_add_external_disabled_tooltip:
    'Please provide your energy tariff in the <a href="/auszahlung">Home Charging Reimbursement</a> section first.',
  external_rfid_univers_card_warning:
    'The card with provided visible Number is a Univers-RFID Card and is automatically added to your account.',
}
